(function () {
  'use strict';

  const header = document.querySelector('[data-yl-header]');
  if (!header) return;

  const normalizePath = (value) => {
    const url = new URL(value || '/', window.location.origin);
    let path = url.pathname.replace(/\/+$/, '') || '/';
    const shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (shopRoot && shopRoot !== '/') {
      const rootPath = new URL(shopRoot, window.location.origin).pathname.replace(/\/+$/, '');
      if (rootPath && rootPath !== '/' && path.indexOf(rootPath + '/') === 0) {
        path = path.slice(rootPath.length) || '/';
      } else if (path === rootPath) {
        path = '/';
      }
    } else {
      path = path.replace(/^\/zh(?=\/|$)/, '') || '/';
    }
    return path;
  };

  const currentPath = normalizePath(window.location.href);
  const markCurrent = (link) => {
    if (link) link.setAttribute('aria-current', 'page');
  };

  // Header HTML can be section/CDN cached without reliable per-page Liquid context
  // (线上实测, 2026-07-03); browser location is authoritative for shop-nav state.
  header
    .querySelectorAll('.yl-shopnav__link[aria-current="page"], .yl-shopnav__trigger[aria-current="page"], .yl-mmenu__shop-link[aria-current="page"]')
    .forEach((link) => link.removeAttribute('aria-current'));

  // /collections (index) has no menu item since "Shop all" left the main menu (user, 2026-11-01);
  // the old first-/collections-link rule would now wrongly mark Aquarium Bundles.
  if (currentPath === '/collections') return;

  header.querySelectorAll('[data-yl-shop-trigger][href], .yl-bundle-nav[href]').forEach((trigger) => {
    const targetPath = normalizePath(trigger.getAttribute('href'));
    if (!targetPath || targetPath === '/' || targetPath === '/collections') return;

    const isBrands = targetPath === '/collections/brands';
    if (
      currentPath === targetPath ||
      currentPath.indexOf(targetPath + '/') === 0 ||
      currentPath.indexOf(targetPath + '-') === 0 ||
      (isBrands && currentPath.indexOf('/collections/brand-') === 0)
    ) {
      markCurrent(trigger);
    }
  });
})();
